import { apiClient } from '../api';
import { Path } from '../api/backendUrl';
import axios from 'axios';

export interface AccountDeletionRequest {
  email: string;
  userId: string;
  scheduledDeletionDate: string;
  requestDate: string;
  status: 'pending' | 'cancelled' | 'completed';
  gracePeriodDays: number;
}

export interface AccountDeletionResponse {
  success: boolean;
  message: string;
  deletionRequest?: AccountDeletionRequest;
  errorId?: string;
}

export interface DeleteRequestResponse {
  success: boolean;
  message: string;
  errorId?: string;
  deletionToken?: string;
  securityToken?: string;
  resendCount?: string;
}

export interface ReactivationResponse {
  success: boolean;
  message: string;
  errorId?: string;
}

const USER_ENDPOINT = import.meta.env.VITE_APP_BACKEND_USER;

//STEP-01
export const requestUserDeletion = async (
  accountType: string
): Promise<DeleteRequestResponse> => {
  try {
    const response = await apiClient.post(
      `${USER_ENDPOINT}/${Path.deleteRequest}`,
      {
        accountType,
      }
    );

    return {
      success: response?.data?.success ?? true,
      securityToken: response?.data?.data?.securityToken,
      message:
        response?.data?.message || 'OTP code sent. Please check your email.',
    };
  } catch (error) {
    console.error('Error requesting account deletion:', error);

    if (axios.isAxiosError(error) && error.response?.data) {
      const backendMessage =
        error.response.data.message ||
        'Rate limit exceeded. Please try again later.';
      throw new Error(backendMessage);
    }

    throw error;
  }
};

export const confirmUserDeletion = async (payload: {
  accountType: string;
  otp: string;
  securityToken: string;
}): Promise<DeleteRequestResponse> => {
  try {
    const response = await apiClient.post(
      `${USER_ENDPOINT}/${Path.verifyDeleteOtp}`,
      payload
    );

    return {
      success: response?.data?.success ?? true,
      message:
        response?.data?.message || 'Account deletion confirmed successful.',
    };
  } catch (error: any) {
    console.error('Error requesting account deletion:', error);

    if (axios.isAxiosError(error) && error.response?.data) {
      const backendMessage =
        error.response.data.message ||
        'Rate limit exceeded. Please try again later.';
      throw new Error(backendMessage);
    }
    throw error;
  }
};
